import { useaxios } from "../../../utils/useaxios";
export default (company_invoice_type, company_invoice_date, company_invoice_note, company_invoice_number, company_id, user_id, company_invoice_rmb_price, company_invoice_cbi_price, items) => recaller => setrecaller => initDispatch => clear => {
    var today = new Date();
    today = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
    initDispatch({ type: 'loadingTrue' });
    useaxios('company_invoice/create.php', { company_invoice_type, company_invoice_date, company_invoice_note, company_invoice_number, company_id, user_id, company_invoice_rmb_price, company_invoice_cbi_price, items }).then((res) => {
        if (res == "Unauthorized") {
            clear();
            return;
        } else if (res == "request_failed") {
            alert('no internet connection');
            initDispatch({ type: 'loadingFalse' });
            return false;
        } else if (res.status == "ok") {
            setrecaller(recaller + 1);
        }
        // setloading(false);
    });
}